import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useAuthStore = defineStore("auth", () => {
    const token = ref<string | null>(localStorage.getItem("auth_token"));

    const isAuthenticated = computed(() => token.value !== null);

    function login(username: string, password: string): boolean {
        if (username === "pras@test.com" && password === "TOTO123tata123@") {
            token.value = "local-session-token";
            localStorage.setItem("auth_token", token.value);
            return true;
        }
        return false;
    }

    function logout() {
        token.value = null;
        localStorage.removeItem("auth_token");
    }

    return { token, isAuthenticated, login, logout };
});
